module.exports = __webpack_public_path__ + "static/media/Dash-Discount.f25b0626.svg";